
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import PaymentMode from '@/shared/enums/PaymentMode'
import {
  methodLabel,
  methodShortLabel,
  methodImage,
  hasMethodImage,
} from '@/shared/utils/paymentMethodHelpers'
import isMobile from '@/widget/utils/isMobile'
import EPanel from './Panel.vue'

@Component({
  components: { EPanel },
})
export default class CheckoutPaymentMethods extends Vue {
  @Prop({ required: true, type: Array }) readonly availableMethods!: PaymentMode[]
  @Prop({ required: true }) readonly selectedMethod!: PaymentMode

  isMobile = isMobile()

  @Emit('select-method')
  handleMethodSelection(method: PaymentMode): PaymentMode {
    return method
  }

  getMethodLabel(method: PaymentMode): string {
    return methodLabel(method)
  }

  getMethodShortLabel(method: PaymentMode): string {
    return methodShortLabel(method)
  }

  getMethodImage(method: PaymentMode): string | null {
    return methodImage(method)
  }

  hasImage(method: PaymentMode): boolean {
    return hasMethodImage(method)
  }
}
